import { useEffect, useState } from "react";

interface OAuthLoadingScreenProps {
  message?: string;
  submessage?: string;
}

/**
 * Reusable loading screen component for OAuth flows
 * Shows a spinner with "Completing Sign In..." message by default
 */
export const OAuthLoadingScreen: React.FC<OAuthLoadingScreenProps> = ({
  message = "Completing Sign In...",
  submessage = "Please wait while we securely log you in.",
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    // Return a simple div during SSR to avoid hydration mismatch
    return (
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "#f8f9fa",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        fontFamily: "system-ui, sans-serif",
        backgroundColor: "#f8f9fa",
        paddingTop: "60px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: "40px",
          height: "40px",
          border: "4px solid #e3e3e3",
          borderTop: "4px solid #47B1A1",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
          margin: "0 auto 20px auto",
        }}
      />

      <h2 style={{ color: "#333", marginBottom: "16px", fontWeight: 600 }}>
        {message}
      </h2>

      <p style={{ color: "#666", fontSize: "14px", lineHeight: "1.5" }}>
        {submessage}
      </p>

      <style jsx>{`
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default OAuthLoadingScreen;